import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ItemsHelperService } from '../../helpers/items-helper.service';
import { GeneralHttpHelperService } from '../../helpers/general-http-helper.service';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

const HOME_API_ROUTES = {
  GET_NEAR_YOU_MAP_DATA: 'items/locations/nearby',
}

@Injectable({
  providedIn: 'root'
})
export class NearYouHttpService {

  constructor(
    private httpClient: HttpClient,
    private itemsHelperService: ItemsHelperService,
    private generalHttpHelperService: GeneralHttpHelperService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  async openGoogleMaps(userLat: number, userLng: number, markerLat: number, markerLng: number) {
    if (isPlatformBrowser(this.platformId)) {
      const url = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${markerLat},${markerLng}&travelmode=driving`;
      await window.open(url, '_blank');
    }
  }

  private getNearYouMapDataReq(urlParams: any): Observable<any> {
    const url = this.generalHttpHelperService.addUrlParams(HOME_API_ROUTES.GET_NEAR_YOU_MAP_DATA, urlParams)
    return this.httpClient.get(url);
  }

  getNearYouMapData(urlParams: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getNearYouMapDataReq(urlParams).subscribe((res: any) => {
        resolve({
          groups: this.itemsHelperService.formatDataForMarkers(res.data.groups),
          groupsRaw: res.data.groups,
          subcategories: res.data.subcategories
        });
      }, error => {
        reject(error);
      });
    });
  }
}
